.container {
	display: flex;
	flex-direction: column;

	width: 100%;
	height: 100%;
	border-radius: 8px;

	background-color: #1c1d23;
	overflow: hidden; /* Prevent scrollbars */

	padding: auto;
}

.signatureContainer {
	background-color: unset;
	border: 1px solid rgb(100, 100, 100, 0.25);
	border-radius: 4px;
}

.imageContainer {
	display: flex;

	justify-content: center;
	align-items: center;

	position: relative;
	flex: 1; /* Take available space */
	width: 100%;

	overflow: hidden; /* Prevent scrollbars */
	/* Fixed height to ensure consistency when paginating */
	min-height: 300px;

	padding: 12px 24px;
	box-sizing: border-box;
}

.image {
	max-width: 90%; /* Slightly reduce max width to prevent potential overflow */
	max-height: 90%; /* Slightly reduce max height to prevent potential overflow */
	object-fit: contain;
	/* Set fixed aspect ratio container to maintain consistent UI */
	width: auto;
	height: auto;
}

.hidden {
	display: none;
}

.visible {
	display: block;
}

.navigationControls {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 12px 24px;
	background-color: rgba(0, 0, 0, 0.2);
	flex-shrink: 0; /* Prevent controls from shrinking */
	box-sizing: border-box; /* Ensure padding is included in width calculation */
}

.navigationButton {
	background-color: #42296e;
	color: white;
	border: none;
	border-radius: 4px;
	padding: 8px 16px;
	cursor: pointer;
	font-size: 14px;
	min-width: 90px; /* Ensure consistent button width */
	margin: 0 4px; /* Add margin on sides to prevent cutoff */
}

.navigationButton :disabled {
	background-color: #555;
	cursor: not-allowed;
}

.navigationButton {
	width: 80px;
}

.pagination {
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	flex: 0 1 auto; /* Allow pagination to shrink if needed */
}

.errorContainer {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	height: 100%;

	color: white;

	text-align: center;
	padding: 0px;
}

.errorImage {
	height: 150px;
}

.errorText {
	font-size: 20px;
	font-weight: 600;
}
